import { React, useEffect, useState, useContext } from 'react'
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from '../../../../App';
import { API_URL } from '../../../../Constant';
import { AnnualAverageOfRuralUrbanWageIndexOfUPReport } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import { changeDateFormat } from "../../../../Custom/Custom";
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../../assets/Messages.json';
import priceTitle from '../../../../price.json';


function AnnualAverageOfRuralUrbanWageIndexOfUP() {
  const token = useContext(MyContextProvider).token;

  const [years, setYears] = useState([]);
  const [yearName, setYearName] = useState("");
  const [yearType, setYearType] = useState("");
  const storedLanguage = localStorage.getItem('language');
  const navigate = useNavigate();
  const config = {
      headers: {
          Authorization: `Bearer ${token}`,
      },
  };


  useEffect(() => { //Get all Years Data
      //Years
     const fetchYears = async () => {
        showLoading(true)
  
        const currentYear = new Date().getFullYear();
        const endYear = 2001;
        const yearsArray = [];
  
        for (let year = currentYear; year >= endYear; year--) {
          yearsArray.push(`${year}-${year + 1}`);
        }
  
        setYears(yearsArray);
        showLoading(false);
      };
  
    fetchYears();
  }, []);
  


// Handle on change Event ********
const handleDropdownChange = (e) => {

  switch (e.target.name) {
      case "yearName":
      setYearName(e.target.value);
      break;
      case "yearType":
      setYearType(e.target.value);
      break;
  default:
      console.log("switch case are not match");
      break;
  }
  };

 const formatGrossValue = (value) => {
    if (value === 0) return '0.0';
    if (value === "NaN" ) return '';
    if (value === '' || value === null || value === 'null') return '0.0';
    return Number(value).toFixed(2);
 };


// Function to generate Excel file using mapped data
const handleGenerateExcel = async () => {

  if (!yearType) {
      toast.error("Please select Year Type", messages.COLOR_RED);
      return;
  }
  if (!yearName) {
      toast.error("Please select Year", messages.COLOR_RED);
      return;
  }
 
 try{

    let postData = {
          yearType: yearType,
          year:yearName
      }
  showLoading(true);
  const response = await axios.post(`${API_URL}api/price/AnnualAveRuralUrbanWageIndex`, postData, config);
  const allData = response.data;
   if(allData.status){
          downloadReport(allData.data.GroupCodes,yearName,yearType)
      }else{
         toast.error(`Data is not found`, messages.COLOR_RED);
      }

  } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
  } finally {
      showLoading(false);
  }

}


// handle Download All report Data ****************
const downloadReport=(allData,yearName,yearType)=>{


let reportData=allData.map(item => [
  item.year,
  formatGrossValue(item.R_CARPENTER),
  formatGrossValue(item.R_MASON),
  formatGrossValue(item.R_UNSKILLED_LABOUR),
  formatGrossValue(item.CARPENTER),
  formatGrossValue(item.MASON),
  formatGrossValue(item.UNSKILLED_LABOUR),

  ]);

  


let reportStructure = {
          year:yearName,
          fileName:`LWS_Annual_AverageWagesIndexUP_${yearName.split('-')[0]}`,
          fileType:'xls',
          sheetName: 'PriAnnualAverageRUWageIndexStat',
          firstRowMergeCells: "A1:G1",
          firstRowExportDate:  changeDateFormat(new Date()),
          secondRowMergeCells: "A2:G2",
          secondRowText:'सारिणी-1(1) उत्तर प्रदेश का ग्रामीण एवं नगरीय मजदूरी दर सूचकांक का वार्षिक औसत',  
          thirdRowMergeCells: "A3:G3" , 
          thirdRowText:'कृषिःवर्ष: 2011-12=100',  
          fourthRowMergeCells: "A4:G4",
          fourthRowText:'Table-1(1)Annual average of Rural & Urban wage index of U.P.', 
          fifthRowMergeCells: "A5:G5",
          fifthRowText:'Agr: Year: 2011-12=100',
          sixthRowMergeCells: "A6:G6",
          sixthRowText:(yearType==='f')?'(वित्तीय वर्ष)':'(कृषि वर्ष)', 
          headerHindiColumns1: ['अवधि','ग्रामीण मजदूरी दर के सूचकंाक','','','नगरीय मजदूरी दर के सूचकंाक','','' ],
          headerHindiColumns2: [(yearType==='f')?'(वित्तीय वर्ष)':'(कृषि वर्ष)','बढ़ई','राज','कृषि श्रमिक','बढ़ई','राज','अकुशल श्रमिक' ],
          headerenglishColumns3: ['Period','CARPENTER','MASON','Agri.Labour','CARPENTER','MASON','Unskilled Labour' ],
          headerYearMergeColumns: "A10:G10",
          headerYearColumns: (yearType==='f')?'(Financial Year)':'(Agriculture Year)',//['(Fin.Year)','','','','','',''],
          headerNumberColumns: [1,2,3,4,5,6,7],
          excelRowData:reportData
 }
   AnnualAverageOfRuralUrbanWageIndexOfUPReport(reportStructure)
}

  return (
    <>
    <ToastContainer />
    <GlobalLoading />
    <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
                <div className="row align-items-center">
                    <h4 className="page_heading">
                     <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.ANNUAL_AVERAGE_OF_RURAL_URABN : priceTitle.en.ANNUAL_AVERAGE_OF_RURAL_URABN }} />
              
                    </h4>
                    <div className="row align-items-center">
                        

                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                            <label className="fw-bold h6"> Select Year Type	</label>
                            <select
                            name="yearType"
                            className="form-select"
                            onChange={handleDropdownChange}
                            value={yearType}
                            >
                            <option value="" disabled>Select Month</option>
                            <option  value="f">  Financial Year </option>
                            <option  value="a">  Agriculture Year </option>
                         </select>
                        </div>

                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                            <label className="fw-bold h6"> Select Year</label>
                            <select
                            name="yearName"
                            className="form-select"
                            onChange={handleDropdownChange}
                            value={yearName}
                            >
                            <option value="" disabled >Select Year</option>
                            {years.map((ele, index) => (
                                <option key={index} value={ele}>
                                {ele}
                                </option>
                            ))}
                         </select>
                        </div>
                      <div className="col-xl-2 col-lg-4 mb-3">
                            <label className="w-100 d-none d-sm-block">&nbsp;</label>
                            <button onClick={handleGenerateExcel} className="btn btn_orange">Search</button>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
   </>
  )
}

export default AnnualAverageOfRuralUrbanWageIndexOfUP